export default "__VITE_ASSET__Fpq4skwh__"